<template>
    <div>
    <!-- 移动端卡片模式 -->
    <div v-if="cardMode" class="space-y-3">
        <!-- 手动刮削按钮卡片 -->
        <div class="card bg-base-100 border border-base-200 hover:shadow-lg transition-all duration-200 hover:scale-[1.02]">
            <div class="card-body p-4">
                <div @click="handModifyCheckBox = true" class="flex items-center justify-between cursor-pointer">
                    <div class="flex items-center space-x-3">
                        <div class="p-2 bg-success/10 rounded-lg">
                            <svg viewBox="0 0 15 15" class="w-6 h-6 fill-success" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.9697 0.969727L4.96973 8.96973L6.03039 10.0304L14.0304 2.03039L12.9697 0.969727Z" />
                                <path d="M2.5 1.25006C1.25736 1.25006 0.25 2.25742 0.25 3.50006V12.5001C0.25 13.7427 1.25736 14.7501 2.5 14.7501H11.5C12.7426 14.7501 13.75 13.7427 13.75 12.5001V7.00006H12.25V12.5001C12.25 12.9143 11.9142 13.2501 11.5 13.2501H2.5C2.08579 13.2501 1.75 12.9143 1.75 12.5001V3.50006C1.75 3.08585 2.08579 2.75006 2.5 2.75006H8V1.25006H2.5Z" />
                            </svg>
                        </div>
                        <div>
                            <div class="font-medium text-base-content">手动刮削</div>
                            <div class="text-sm text-base-content/70">手动编辑音乐标签信息</div>
                        </div>
                    </div>
                    <div class="flex-shrink-0">
                        <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                        <svg v-else class="w-5 h-5 fill-current text-base-content/50" viewBox="0 0 20 20">
                            <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- 自动刮削按钮卡片 -->
        <div class="card bg-base-100 border border-base-200 hover:shadow-lg transition-all duration-200 hover:scale-[1.02]">
            <div class="card-body p-4">
                <div @click="autoModifyCheckBox = true" class="flex items-center justify-between cursor-pointer">
                    <div class="flex items-center space-x-3">
                        <div class="p-2 bg-primary/10 rounded-lg">
                            <svg t="1733029861980" class="w-6 h-6 fill-primary" viewBox="0 0 1036 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9646">
                                <path d="M938.74776 69.162438L893.455144 52.837457a67.26383 67.26383 0 1 0-20.007307 64.317969l42.469499 15.465771c28.722146 10.433258 53.516478 49.097686 53.516478 83.466066v598.869028c0 34.000148-24.548843 72.664576-53.639223 82.729601l-38.296195 13.501863a67.26383 67.26383 0 1 0 14.115585 66.650109l46.397313-16.447724c55.60313-19.51633 98.195372-83.711555 98.195373-146.311105V216.210008c0-62.354061-42.960475-126.917519-98.195373-147.293059zM222.16703 888.971053a66.895597 66.895597 0 0 0-52.166292 24.548843L121.516773 897.440403A89.1123 89.1123 0 0 1 67.26383 822.443688V208.722611a89.97151 89.97151 0 0 1 54.252943-76.101414l51.920803-18.657121a67.632063 67.632063 0 1 0-15.465771-65.913643L98.195372 69.285182A157.358084 157.358084 0 0 0 0 208.722611v613.721077a156.253386 156.253386 0 0 0 99.30007 138.332731L159.56748 982.011168a67.509318 67.509318 0 1 0 62.59955-93.040115z" />
                                <path d="M426.29066 572.413721l86.780161-205.105584 91.935417 205.105584z m282.311696 230.759125h119.798354l-267.58239-592.854561-98.195372 1.104698-251.625642 592.118096 118.079936-1.350187L380.507068 680.183142h272.492158l55.112153 122.744215z" />
                            </svg>
                        </div>
                        <div>
                            <div class="font-medium text-base-content">自动刮削</div>
                            <div class="text-sm text-base-content/70">自动匹配音乐标签信息</div>
                        </div>
                    </div>
                    <div class="flex-shrink-0">
                        <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                        <svg v-else class="w-5 h-5 fill-current text-base-content/50" viewBox="0 0 20 20">
                            <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 桌面端原有模式 -->
    <div v-else>
        <!-- 手动刮削按钮 -->
        <div class="mt-2">
            <div for="hand-edit"
                :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content drawer-button', !detail ? 'tooltip tooltip-top' : '']"
                data-tip="手动刮削" @click="handModifyCheckBox = true">
                <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                <span v-else :class="['flex mt-1', 'items-center', detail ? 'w-40' : '']">
                    <svg viewBox="0 0 15 15" class="icon fill-current w-16 h-5" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.9697 0.969727L4.96973 8.96973L6.03039 10.0304L14.0304 2.03039L12.9697 0.969727Z" />
                        <path
                            d="M2.5 1.25006C1.25736 1.25006 0.25 2.25742 0.25 3.50006V12.5001C0.25 13.7427 1.25736 14.7501 2.5 14.7501H11.5C12.7426 14.7501 13.75 13.7427 13.75 12.5001V7.00006H12.25V12.5001C12.25 12.9143 11.9142 13.2501 11.5 13.2501H2.5C2.08579 13.2501 1.75 12.9143 1.75 12.5001V3.50006C1.75 3.08585 2.08579 2.75006 2.5 2.75006H8V1.25006H2.5Z" />
                    </svg>
                    <div v-if="detail" class="mr-auto">手动刮削</div>
                </span>
            </div>
        </div>

        <!-- 自动刮削按钮 -->
        <div class="mt-2">
            <div @click="autoModifyCheckBox = true"
                :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content drawer-button', !detail ? 'tooltip tooltip-top' : '']"
                data-tip="自动刮削">
                <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                <span v-else :class="['flex mt-1', 'items-center', detail ? 'w-40' : '']">
                    <svg t="1733029861980" class="icon fill-current w-16 h-5" viewBox="0 0 1036 1024" version="1.1"
                        xmlns="http://www.w3.org/2000/svg" p-id="9646" width="200" height="200">
                        <path
                            d="M938.74776 69.162438L893.455144 52.837457a67.26383 67.26383 0 1 0-20.007307 64.317969l42.469499 15.465771c28.722146 10.433258 53.516478 49.097686 53.516478 83.466066v598.869028c0 34.000148-24.548843 72.664576-53.639223 82.729601l-38.296195 13.501863a67.26383 67.26383 0 1 0 14.115585 66.650109l46.397313-16.447724c55.60313-19.51633 98.195372-83.711555 98.195373-146.311105V216.210008c0-62.354061-42.960475-126.917519-98.195373-147.293059zM222.16703 888.971053a66.895597 66.895597 0 0 0-52.166292 24.548843L121.516773 897.440403A89.1123 89.1123 0 0 1 67.26383 822.443688V208.722611a89.97151 89.97151 0 0 1 54.252943-76.101414l51.920803-18.657121a67.632063 67.632063 0 1 0-15.465771-65.913643L98.195372 69.285182A157.358084 157.358084 0 0 0 0 208.722611v613.721077a156.253386 156.253386 0 0 0 99.30007 138.332731L159.56748 982.011168a67.509318 67.509318 0 1 0 62.59955-93.040115z">
                        </path>
                        <path
                            d="M426.29066 572.413721l86.780161-205.105584 91.935417 205.105584z m282.311696 230.759125h119.798354l-267.58239-592.854561-98.195372 1.104698-251.625642 592.118096 118.079936-1.350187L380.507068 680.183142h272.492158l55.112153 122.744215z">
                        </path>
                    </svg>
                    <div v-if="detail" class="mr-auto">自动刮削</div>
                </span>
            </div>
        </div>
    </div>

    <!-- 通用 Drawer (移动端和桌面端共用) -->
    <!-- 手动编辑 Drawer -->
    <div class="drawer">
        <input id="hand-edit" type="checkbox" class="drawer-toggle" v-model="handModifyCheckBox" />
        <div class="drawer-side">
            <div @click="handModifyCheckBox = false" aria-label="close sidebar" class="drawer-overlay"></div>
            <div class="p-4 min-h-full bg-base-100 text-base-content w-80 md:w-96">
                <div class="flex justify-between items-center mb-4">
                    <div class="text-xl font-medium">手动修改标签</div>
                    <div>
                        <button class="btn btn-sm btn-neutral" @click="handleBatch(false)">确认</button>
                        <button class="btn btn-sm ml-1" @click="handModifyCheckBox = false">取消</button>
                    </div>
                </div>
                <div style="display: flex;margin-bottom: 10px;align-items: center;margin-top: 10px;">
                    <div class="label1 can-copy">标题：</div>
                    <div style="width: 70%;">
                        <single-input v-model="musicInfoManual.title" placeholder="支持变量批量修改">
                        </single-input>
                    </div>
                </div>
                <div v-for="(item, index) in showFields" :key="'l2' + index">
                    <div class="edit-item" v-if="item === 'filename'">
                        <div class="label1 can-copy">
                            文件名：
                        </div>
                        <div style="width: 70%;">
                            <single-input v-model="musicInfoManual.filename" placeholder="例如：${title}-${album}">
                            </single-input>
                        </div>
                    </div>
                    <div class="edit-item" v-else-if="item === 'artist'">
                        <div class="label1 can-copy">
                            艺术家：
                        </div>
                        <div style="width: 70%;">
                            <single-input v-model="musicInfoManual.artist" placeholder="输入$查看可选择的变量">
                            </single-input>
                        </div>
                    </div>
                    <div class="edit-item" v-else-if="item === 'album'">
                        <div class="label1 can-copy">专辑：
                        </div>
                        <div style="width: 70%;">
                            <single-input v-model="musicInfoManual.album" placeholder="${null}为清空标签">
                            </single-input>
                        </div>
                    </div>
                    <div class="edit-item" v-else-if="item === 'albumartist'">
                        <div class="label1 can-copy">专辑艺术家：
                        </div>
                        <div style="width: 70%;">
                            <div class="w-full max-w-xs">
                                <single-select :options="albumArtistList" v-model="musicInfoManual.albumartist"
                                    is-var>
                                </single-select>
                            </div>
                        </div>
                    </div>
                    <div class="edit-item" v-else-if="item === 'genre'">
                        <div class="label1">风格：</div>
                        <div style="width: 70%;">
                            <div class="w-full max-w-xs">
                                <single-select :options="genreList" v-model="musicInfoManual.genre" is-var>
                                </single-select>
                            </div>
                        </div>
                    </div>
                    <div class="edit-item" v-else-if="item === 'language'">
                        <div class="label1">语言：</div>
                        <div style="width: 70%;">
                            <div class="w-full max-w-xs">
                                <single-select :options="languageList" v-model="musicInfoManual.language" is-var>
                                </single-select>
                            </div>
                        </div>
                    </div>
                    <div class="edit-item" v-else-if="item === 'year'">
                        <div class="label1">年份：</div>
                        <div style="width: 70%;">
                            <single-input v-model="musicInfoManual.year" type="number">
                            </single-input>
                        </div>
                    </div>
                    <div style="display: flex;margin-bottom: 10px;flex-direction: column;"
                        v-else-if="item === 'lyrics'">
                        <div style="display: flex;">
                            <div class="label1">歌词：</div>
                            <div style="display: flex;flex-direction: column;width: 70%;">
                                <div>
                                    <div class="form-control w-full max-w-xs">
                                        <textarea placeholder="请填入歌词" v-model="musicInfoManual.lyrics"
                                            class="textarea textarea-bordered textarea-xs w-full max-w-xs h-48">
                                            </textarea>
                                        <label class="label">
                                            <span class="label-text-alt">
                                                <div style="display: flex;margin-top: 10px;">
                                                    <div class="text-xs tooltip"
                                                        data-tip="将元数据中的歌词导出为 ${filename}.lrc ">导出 lrc:</div>
                                                    <input type="checkbox" class="toggle toggle-xs toggle-primary"
                                                        v-model="isSaveLyricsFile" />
                                                </div>
                                            </span>
                                            <span class="label-text-alt">
                                                <div style="display: flex;margin-top: 10px;">
                                                    <div class="text-xs tooltip"
                                                        data-tip="将${filename}.lrc文件导入元数据中的歌词处">导入 lrc:</div>
                                                    <input type="checkbox" class="toggle toggle-xs toggle-primary"
                                                        v-model="isImportLyricsFile" />
                                                </div>
                                            </span>
                                            <span class="label-text-alt">
                                                <div style="display: flex;margin-top: 10px;">
                                                    <div class="text-xs tooltip" data-tip="将歌词翻译为中文">翻译歌词:</div>
                                                    <input type="checkbox" class="toggle toggle-xs toggle-primary"
                                                        v-model="isTranslateLyrics" />
                                                </div>
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="edit-item" v-else-if="item === 'comment'">
                        <div class="label1">简介：</div>
                        <div style="width: 70%;">
                            <textarea placeholder="请填入描述" v-model="musicInfoManual.comment"
                                class="textarea textarea-bordered textarea-xs w-full max-w-xs">
                                </textarea>
                        </div>
                    </div>
                    <div class="edit-item" v-else-if="item === 'description'">
                        <div class="label1">描述：</div>
                        <div style="width: 70%;">
                            <textarea placeholder="请填入描述" v-model="musicInfoManual.description"
                                class="textarea textarea-bordered textarea-xs w-full max-w-xs">
                                </textarea>
                        </div>
                    </div>
                    <div class="edit-item" v-else-if="item === 'album_img'">
                        <div class="label1">专辑封面：</div>
                        <div style="display: flex;flex-direction: column;">
                            <div style="width: 70%;display: flex;flex-direction: column;" v-if="reloadImg">
                                <!-- 图片上传 -->
                                <div class="relative">
                                    <!-- 图片预览区域 -->
                                    <div
                                        class="border-2 border-dashed border-gray-300 rounded-lg p-2 text-center hover:border-gray-400 transition-colors">
                                        <div v-if="albumImagePreview" class="relative inline-block">
                                            <img :src="albumImagePreview" alt="专辑封面"
                                                class="max-w-full max-h-48 rounded-lg shadow-md">
                                            <button @click.stop="removeAlbumImage"
                                                class="absolute -top-2 -right-2 btn btn-circle btn-xs btn-error text-white hover:bg-red-600 z-50"
                                                type="button" style="pointer-events: auto;">
                                                ✕
                                            </button>
                                            <!-- 替换图片按钮 -->
                                            <button @click.stop="triggerAlbumImageReplacement"
                                                class="absolute -bottom-2 -right-2 btn btn-circle btn-xs btn-neutral text-white z-50"
                                                type="button" style="pointer-events: auto;" title="替换图片">
                                                +
                                            </button>

                                        </div>
                                        <div v-else>
                                            <svg class="mx-auto h-12 w-12 text-gray-400" stroke="currentColor"
                                                fill="none" viewBox="0 0 48 48">
                                                <path
                                                    d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                                                    stroke-width="2" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                            <p class="mt-2 text-sm text-gray-500">点击上传或拖拽图片到此处</p>
                                            <p class="text-xs text-gray-400">支持 JPG, PNG, GIF (最大 5MB)</p>
                                        </div>

                                        <!-- 隐藏的文件输入 -->
                                        <input ref="albumImageInput" type="file" accept="image/*"
                                            @change="handleAlbumImageChange"
                                            class="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
                                            :disabled="isUploadingAlbumImage" v-show="!albumImagePreview">
                                        <!-- 上传进度 -->
                                        <div v-if="isUploadingAlbumImage"
                                            class="absolute inset-0 bg-white bg-opacity-75 flex items-center justify-center rounded-lg">
                                            <div class="text-center">
                                                <span class="loading loading-spinner loading-md"></span>
                                                <p class="mt-2 text-sm text-gray-600">上传中...</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style="display: flex;margin-top: 10px;">
                                <div class="text-xs mr-1">导出图片：</div>
                                <input type="checkbox" class="toggle toggle-xs toggle-primary"
                                    v-model="isSaveAlbumCover" />
                                <div class="text-xs mr-1 ml-8">导入图片：</div>
                                <input type="checkbox" class="toggle toggle-xs toggle-primary"
                                    v-model="isImportAlbumCover" />
                            </div>
                        </div>
                    </div>
                    <!-- 其他字段省略，与原代码保持一致 -->
                    <div class="edit-item" v-else-if="item === 'discnumber'">
                        <div class="label1 can-copy">光盘编号：
                        </div>
                        <div style="width: 70%;">
                            <single-input v-model="musicInfoManual.discnumber">
                            </single-input>
                        </div>
                    </div>
                    <div class="edit-item" v-else-if="item === 'tracknumber'">
                        <div class="label1 can-copy">音轨号：
                        </div>
                        <div style="width: 70%;">
                            <single-input v-model="musicInfoManual.tracknumber">
                            </single-input>
                        </div>
                    </div>
                    <div class="edit-item" v-else-if="item === 'totaltracks'">
                        <div class="label1 can-copy">总音轨数：</div>
                        <div style="width: 70%;">
                            <single-input v-model="musicInfoManual.totaltracks">
                            </single-input>
                        </div>
                    </div>
                    <div class="edit-item" v-else-if="item === 'totaldiscs'">
                        <div class="label1">总光盘数：</div>
                        <div style="width: 70%;">
                            <single-input v-model="musicInfoManual.totaldiscs">
                            </single-input>
                        </div>
                    </div>
                    <div class="edit-item" v-else-if="item === 'album_type'">
                        <div class="label1">专辑类型：</div>
                        <div style="width: 70%;">
                            <single-select :options="albumTypeList" v-model="musicInfoManual.album_type">
                            </single-select>
                        </div>
                    </div>
                    <div class="edit-item" v-else-if="item === 'replaygain_album_gain'">
                        <div class="label1">专辑增益：</div>
                        <div style="width: 70%;">
                            <single-input v-model="musicInfoManual.replaygain_album_gain">
                            </single-input>
                        </div>
                    </div>
                    <div class="edit-item" v-else-if="item === 'replaygain_album_peak'">
                        <div class="label1">专辑峰值：</div>
                        <div style="width: 70%;">
                            <single-input v-model="musicInfoManual.replaygain_album_peak">
                            </single-input>
                        </div>
                    </div>
                    <div class="edit-item" v-else-if="item === 'replaygain_track_gain'">
                        <div class="label1">曲目增益：</div>
                        <div style="width: 70%;">
                            <single-input v-model="musicInfoManual.replaygain_track_gain">
                            </single-input>
                        </div>
                    </div>
                    <div class="edit-item" v-else-if="item === 'replaygain_track_peak'">
                        <div class="label1">曲目峰值：</div>
                        <div style="width: 70%;">
                            <single-input v-model="musicInfoManual.replaygain_track_peak">
                            </single-input>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 自动编辑 Drawer -->
    <div class="drawer">
        <input id="auto-edit" type="checkbox" class="drawer-toggle" name='auto-edit' v-model="autoModifyCheckBox" />
        <div class="drawer-side">
            <div @click="autoModifyCheckBox = false" aria-label="close sidebar" class="drawer-overlay"></div>
            <div class="p-4 min-h-full bg-base-100 text-base-content w-80 md:w-96">
                <div class="flex justify-between items-center mb-4">
                    <div class="text-xl font-medium">自动修改标签</div>
                    <div>
                        <button class="btn btn-sm btn-neutral" @click="handleBatchAuto">确认</button>
                        <button class="btn btn-sm ml-1" @click="autoModifyCheckBox = false">取消</button>
                    </div>
                </div>
                <div class="p-4 space-y-6">
                    <div class="bg-info/10 p-4 rounded-lg border border-info/20">
                        <div class="text-sm text-base-content/80 space-y-1">
                            <p>根据元数据中的标题、艺术家、专辑和文件名、文件完整路径进行匹配。</p>
                            <p>标题、艺术家、专辑每一项匹配等级指标：完全一致，包含，不匹配</p>
                        </div>
                    </div>

                    <div class="form-control">
                        <label class="label">
                            <span class="label-text font-medium">匹配模式</span>
                        </label>
                        <div class="space-y-2">
                            <label class="label cursor-pointer justify-start gap-3 p-3 rounded-lg border border-base-200 hover:bg-base-50">
                                <input type="radio" name="radio-auto-mode" class="radio radio-primary" value="simple"
                                    v-model="selectAutoMode" />
                                <div class="flex-1">
                                    <div class="font-medium">宽松模式</div>
                                    <div class="text-xs text-base-content/70">满足标题包含即可，但也优先选完全一致</div>
                                </div>
                            </label>
                            <label class="label cursor-pointer justify-start gap-3 p-3 rounded-lg border border-base-200 hover:bg-base-50">
                                <input type="radio" name="radio-auto-mode" class="radio radio-primary" value="normal"
                                    v-model="selectAutoMode" />
                                <div class="flex-1">
                                    <div class="font-medium">标准模式</div>
                                    <div class="text-xs text-base-content/70">三个指标必须为包含或完全一致，但也优先选完全一致</div>
                                </div>
                            </label>
                            <label class="label cursor-pointer justify-start gap-3 p-3 rounded-lg border border-base-200 hover:bg-base-50">
                                <input type="radio" name="radio-auto-mode" class="radio radio-primary" value="hard"
                                    v-model="selectAutoMode" />
                                <div class="flex-1">
                                    <div class="font-medium">严格模式</div>
                                    <div class="text-xs text-base-content/70">三个指标必须都为完全一致</div>
                                </div>
                            </label>
                        </div>
                    </div>

                    <div class="form-control">
                        <label class="label">
                            <span class="label-text font-medium">标签源选择</span>
                        </label>
                        <multi-select :options="resourceListBatch" v-model="sourceList">
                        </multi-select>
                    </div>

                    <div class="form-control">
                        <label class="label">
                            <span class="label-text font-medium">修改范围</span>
                        </label>
                        <multi-select :options="modifyListBatch" v-model="modifyList">
                        </multi-select>
                    </div>

                    <div class="form-control">
                        <label class="label cursor-pointer justify-start gap-4">
                            <span class="label-text font-medium">跳过匹配</span>
                            <input type="checkbox" class="toggle toggle-primary" 
                                v-model="isSkipTag" />
                        </label>
                        <div class="mt-2 p-3 bg-base-200/50 rounded-lg">
                            <div class="text-sm text-base-content/70">
                                如修改范围中元数据都存在，则跳过匹配，原有音乐标签将被保留，不会被修改或覆盖
                            </div>
                        </div>
                    </div>

                    <div class="form-control">
                        <label class="label cursor-pointer justify-start gap-4">
                            <span class="label-text font-medium">同目录解释为同个专辑</span>
                            <input type="checkbox" class="toggle toggle-primary" 
                                v-model="isFolderAlbum" />
                        </label>
                        <div class="mt-2 p-3 bg-base-200/50 rounded-lg">
                            <div class="text-sm text-base-content/70">
                                当元数据中不存在专辑信息，用于补充专辑信息，提高匹配度
                            </div>
                        </div>
                    </div>
                    <div class="form-control">
                        <label class="label cursor-pointer justify-start gap-4">
                            <span class="label-text font-medium">刮削速率</span>
                            <input type="number" class="input input-bordered input-sm"
                                v-model="scrapeRate" />
                        </label>
                        <div class="mt-2 p-3 bg-base-200/50 rounded-lg">
                            <div class="text-sm text-base-content/70">
                                每秒刮削的音乐文件数量, 基于你机器的性能和网络。
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import SingleSelect from "@/components/iview/SingleSelect";
import SingleInput from "@/components/iview/SingleInput";
import MultiSelect from "@/components/iview/MultiSelect";

export default {
    name: 'TagEditor',
    components: { SingleInput, SingleSelect, MultiSelect },
    props: {
        detail: {
            type: Boolean,
            default: false
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        checkedData: {
            type: Array,
            default: () => []
        },
        filePath: {
            type: String,
            default: ''
        },
        cardMode: {
            type: Boolean,
            default: false
        }
    },
    data() {
        // 辅助函数：从 localStorage 获取值
        const getLocalStorageValue = (key, defaultValue) => {
            try {
                const value = localStorage.getItem(key)
                if (value !== null) {
                    return JSON.parse(value)
                }
            } catch (e) {
                console.warn(`Failed to parse localStorage value for key: ${key}`, e)
            }
            return defaultValue
        }

        return {
            handModifyCheckBox: false,
            autoModifyCheckBox: false,
            musicInfoManual: {},
            showFields: localStorage.getItem('showFields') ? JSON.parse(localStorage.getItem('showFields')) : ['filename', 'artist', 'album', 'albumartist', 'genre', 'year', 'lyrics', 'lyrics_file', 'comment', 'album_img', 'size', 'album_type', 'description', 'discnumber', 'tracknumber', 'totaltracks', 'totaldiscs', 'bit_rate', 'sample_rate', 'channels', 'bit_depth', 'language', 'duration'],
            albumTypeList: [
                { id: 'album;album', name: '普通(album;album)' },
                { id: 'ep', name: 'EP(ep)' },
                { id: 'album;compilation', name: '合集(album;compilation)' },
                { id: 'album;live', name: '现场(album;live)' },
                { id: 'album;remix', name: '混音(album;remix)' },
                { id: 'album;soundtrack', name: '原声(album;soundtrack)' },
                { id: 'album;demo', name: '演示(album;demo)' },
                { id: 'single', name: '单曲(single)' }
            ],
            isSaveLyricsFile: false,
            isSaveAlbumCover: false,
            isImportAlbumCover: false,
            isImportLyricsFile: false,
            isTranslateLyrics: false,
            reloadImg: true,
            uploadUrl: '/apimt/upload_image/',
            files1: [],
            genreList: [
                { 'id': '流行', name: '流行' },
                { 'id': '摇滚', name: '摇滚' },
                { 'id': '说唱', name: '说唱' },
                { 'id': '民谣', name: '民谣' },
                { 'id': '电子', name: '电子' },
                { 'id': '爵士', name: '爵士' },
                { 'id': '纯音乐', name: '纯音乐' },
                { 'id': '金属', name: '金属' },
                { 'id': '世界音乐', name: '世界音乐' },
                { 'id': '新世纪', name: '新世纪' },
                { 'id': '古典', name: '古典' },
                { 'id': '独立', name: '独立' },
                { 'id': '氛围音乐', name: '氛围音乐' }
            ],
            languageList: [
                { 'id': '中文', name: '中文' },
                { 'id': '英文', name: '英文' },
                { 'id': '日文', name: '日文' },
                { 'id': '韩文', name: '韩文' },
                { 'id': '泰文', name: '泰文' },
                { 'id': '未知', name: '未知' },
                { 'id': '${guess_language}', name: '自动识别' }
            ],
            albumArtistList: [],
            // 从 localStorage 读取自动编辑表单数据，如果不存在则使用默认值
            isSkipTag: getLocalStorageValue('autoEdit_isSkipTag', true),
            isFolderAlbum: getLocalStorageValue('autoEdit_isFolderAlbum', false),
            scrapeRate: getLocalStorageValue('autoEdit_scrapeRate', 1),
            modifyList: getLocalStorageValue('autoEdit_modifyList', ['artist', 'album', 'album_img', 'year', 'lyrics']),
            resourceListBatch: [
                { id: 'netease', name: '网易云音乐' },
                { id: 'migu', name: '咪咕音乐' },
                { id: 'qmusic', name: 'QQ音乐' },
                { id: 'kugou', name: '酷狗音乐' },
                { id: 'kuwo', name: '酷我音乐' },
                { id: 'itunes', name: 'iTunes' },
                { id: 'spotify', name: 'Spotify' },
                { id: 'musicbrainz', name: 'MusicBrainz' },
            ],
            modifyListBatch: [
                { id: 'title', name: '标题' },
                { id: 'artist', name: '艺术家' },
                { id: 'album', name: '专辑' },
                { id: 'albumartist', name: '专辑艺术家' },
                { id: 'album_img', name: '专辑封面' },
                { id: 'year', name: '年份' },
                { id: 'lyrics', name: '歌词' },
                { id: 'is_save_lyrics_file', name: '歌词(LRC文件)' },
                { id: 'discnumber', name: '光盘编号' },
                { id: 'tracknumber', name: '音轨号' },
                { id: 'composer', name: '作曲家' },
                { id: 'lyricist', name: '作词家' },
                { id: 'language', name: '语言' }
            ],
            selectAutoMode: getLocalStorageValue('autoEdit_selectAutoMode', 'simple'),
            sourceList: getLocalStorageValue('autoEdit_sourceList', ['netease', 'qmusic']),
             // 新增的图片上传相关数据
             albumImagePreview: null,
            isUploadingAlbumImage: false,
        }
    },
    computed: {
        uploadHeader() {
            return [
                { name: 'X-CSRFToken', value: this.getCookie('django_vue_cli_csrftoken') },
                { name: 'AUTHORIZATION', value: this.getCookie('AUTHORIZATION') }
            ];
        }
    },
    methods: {
        // 移除专辑封面
        removeAlbumImage() {
            this.albumImagePreview = null
            this.musicInfoManual.album_img = ''
            this.musicInfoManual.artwork = ''
            if (this.$refs.albumImageInput) {
                this.$refs.albumImageInput.value = ''
            }
        },
        // 触发专辑封面替换
        triggerAlbumImageReplacement() {
            // 直接创建临时input，更可靠
            this.createTempFileInput('album')
        },
        
        // 创建临时文件输入
        createTempFileInput(type) {
            const input = document.createElement('input')
            input.type = 'file'
            input.accept = 'image/*'
            input.style.display = 'none'
            input.onchange = (event) => {
                if (type === 'album') {
                    this.handleAlbumImageChange(event)
                } else {
                    this.handleArtistImageChange(event)
                }
                // 清理临时元素
                if (input.parentNode) {
                    input.parentNode.removeChild(input)
                }
            }
            document.body.appendChild(input)
            input.click()
        },
        // 渲染图片
        handleRes(response) {
            if (response.result) {
                this.musicInfoManual.album_img = response.data
                return true
            } else {
                return false
            }
        },
        // 新增的图片上传相关方法
        // 处理专辑封面图片选择
        handleAlbumImageChange(event) {
            const file = event.target.files[0]
            if (!file) return
            
            // 验证文件类型
            if (!file.type.startsWith('image/')) {
                this.$myMsg.notify({
                    title: '文件类型错误',
                    content: '请选择图片文件',
                    type: 'error',
                    time: 2000,
                })
                return
            }
            
            // 验证文件大小 (5MB)
            if (file.size > 5 * 1024 * 1024) {
                this.$myMsg.notify({
                    title: '文件过大',
                    content: '图片大小不能超过5MB',
                    type: 'error',
                    time: 2000,
                })
                return
            }
            
            // 显示预览
            const reader = new FileReader()
            reader.onload = (e) => {
                this.albumImagePreview = e.target.result
            }
            reader.readAsDataURL(file)
            
            // 上传图片
            this.uploadImage(file, 'album')
        },
        // 通用图片上传方法
        uploadImage(file, type) {
            const formData = new FormData()
            formData.append('upload_file', file)
            
            // 设置上传状态
            if (type === 'album') {
                this.isUploadingAlbumImage = true
            } else {
                this.isUploadingArtistImage = true
            }
            
            // 创建 XMLHttpRequest
            const xhr = new XMLHttpRequest()
            
            // 设置请求头
            xhr.open('POST', this.uploadUrl, true)
            xhr.setRequestHeader('X-CSRFToken', this.getCookie('django_vue_cli_csrftoken'))
            xhr.setRequestHeader('AUTHORIZATION', this.getCookie('AUTHORIZATION'))
            xhr.withCredentials = true
            
            // 处理响应
            xhr.onload = () => {
                // 重置上传状态
                if (type === 'album') {
                    this.isUploadingAlbumImage = false
                } else {
                    this.isUploadingArtistImage = false
                }
                
                if (xhr.status === 200) {
                    try {
                        const response = JSON.parse(xhr.responseText)
                        if (this.handleRes(response)) {
                            this.$myMsg.notify({
                                title: '上传成功',
                                type: 'success',
                                time: 2000,
                            })
                        } else {
                            this.$myMsg.notify({
                                title: '上传失败',
                                content: response.message || '未知错误',
                                type: 'error',
                                time: 2000,
                            })
                        }
                    } catch (e) {
                        console.log(e)
                        this.$myMsg.notify({
                            title: '上传失败',
                            content: '服务器响应格式错误',
                            type: 'error',
                            time: 2000,
                        })
                    }
                } else {
                    this.$myMsg.notify({
                        title: '上传失败',
                        content: `HTTP错误: ${xhr.status}`,
                        type: 'error',
                        time: 2000,
                    })
                }
            }
            
            // 处理错误
            xhr.onerror = () => {
                if (type === 'album') {
                    this.isUploadingAlbumImage = false
                } else {
                    this.isUploadingArtistImage = false
                }
                this.$myMsg.notify({
                    title: '上传失败',
                    content: '网络错误',
                    type: 'error',
                    time: 2000,
                })
            }
            
            // 发送请求
            xhr.send(formData)
        },
        handleBatch(isRegainer) {
            if (this.checkedData.length === 0) {
                this.$myMsg.notify({
                    title: '发生提示',
                    content: "请先勾选文件或文件夹！",
                    type: 'warning',
                    time: 5000,
                });
                return
            }

            this.$emit('loading-start')

            this.musicInfoManual.is_save_lyrics_file = this.isSaveLyricsFile
            this.musicInfoManual.is_import_lyrics_file = this.isImportLyricsFile
            this.musicInfoManual.is_translate_lyrics = this.isTranslateLyrics
            this.musicInfoManual.is_save_album_cover = this.isSaveAlbumCover
            this.musicInfoManual.is_import_album_cover = this.isImportAlbumCover

            this.$api.Task.batchUpdateId3({
                'file_full_path': this.filePath,
                'select_data': this.checkedData,
                'music_info': this.musicInfoManual,
                'is_regainer': isRegainer
            }).then((res) => {
                this.$emit('loading-end')
                if (res.result) {
                    this.handModifyCheckBox = false
                    this.$myMsg.notify({
                        title: '创建成功！',
                        content: "任务在后台努力运行中",
                        type: 'success',
                        time: 2000,
                        url: '/#/log'
                    });
                } else {
                    this.$myMsg.notify({
                        title: '创建失败！',
                        content: res.message.data.message ? res.message.data.message : '创建失败',
                        type: 'error',
                        time: 5000,
                    })
                }
            }).catch(() => {
                this.$emit('loading-end')
            })
        },

        handleBatchAuto() {
            if (this.checkedData.length === 0) {
                this.$myMsg.notify({
                    title: '发生提示',
                    content: "请先勾选文件或文件夹！",
                    type: 'warning',
                    time: 5000,
                });
                return
            }

            // 保存自动编辑表单设置到 localStorage
            this.saveAutoEditSettings()

            this.$emit('loading-start')

            this.musicInfoManual['select_mode'] = this.selectAutoMode
            this.musicInfoManual['source_list'] = this.sourceList
            this.musicInfoManual['is_skip_tag'] = this.isSkipTag
            this.musicInfoManual['is_folder_album'] = this.isFolderAlbum
            this.musicInfoManual['scrape_rate'] = this.scrapeRate

            this.$api.Task.batchAutoUpdateId3({
                'file_full_path': this.filePath,
                'select_data': this.checkedData,
                'music_info': this.musicInfoManual,
                'modify_list': this.modifyList
            }).then((res) => {
                this.$emit('loading-end')
                if (res.result) {
                    this.autoModifyCheckBox = false
                    this.$myMsg.notify({
                        title: '创建成功！',
                        content: "任务在后台努力运行中",
                        type: 'success',
                        time: 2000,
                        url: '/#/log'
                    });
                } else {
                    this.$myMsg.notify({
                        title: '创建失败！',
                        content: res.message.data.message ? res.message.data.message : '创建失败',
                        type: 'error',
                        time: 5000,
                    })
                }
            }).catch(() => {
                this.$emit('loading-end')
            })
        },

        // 保存自动编辑设置到 localStorage
        saveAutoEditSettings() {
            try {
                localStorage.setItem('autoEdit_selectAutoMode', JSON.stringify(this.selectAutoMode))
                localStorage.setItem('autoEdit_sourceList', JSON.stringify(this.sourceList))
                localStorage.setItem('autoEdit_modifyList', JSON.stringify(this.modifyList))
                localStorage.setItem('autoEdit_isSkipTag', JSON.stringify(this.isSkipTag))
                localStorage.setItem('autoEdit_isFolderAlbum', JSON.stringify(this.isFolderAlbum))
                localStorage.setItem('autoEdit_scrapeRate', JSON.stringify(this.scrapeRate))
            } catch (e) {
                console.warn('Failed to save auto edit settings to localStorage:', e)
            }
        },

        handleResBatch(response) {
            if (response.result) {
                this.musicInfoManual.album_img = response.data
                return true
            } else {
                return false
            }
        },

        handleHide() {
            this.musicInfoManual.album_img = ''
        },

        getCookie(name) {
            let cookieValue = null;
            if (document.cookie && document.cookie !== '') {
                const cookies = document.cookie.split(';');
                for (let i = 0; i < cookies.length; i++) {
                    const cookie = cookies[i].trim();
                    if (cookie.substring(0, name.length + 1) === (name + '=')) {
                        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                        break;
                    }
                }
            }
            return cookieValue;
        }
    }
}
</script>

<style scoped>
.icon {
    @apply fill-current w-16;
}

.edit-item {
    display: flex;
    margin-bottom: 10px;
    align-items: center;
    margin-top: 10px;
}

.label1 {
    width: 30%;
    font-weight: 500;
}

.can-copy {
    cursor: pointer;
}
</style>